import { styled } from '@mui/material/styles';
import { Grid } from '@mui/material';
import { Box } from '../../atoms/Box';

export const RoleBox = styled(Box)`
  width: 97%;
  padding: 10px;
  border: 2px solid #eeeeee;
  border-radius: 5px;
  background-color: #ffffff;
  box-sizing: border-box;
`;

export const ContactGridContainer = styled(Grid)`
  margin-bottom: 10px;
`;
